"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationsFinishedTimeInMins = getNotificationsFinishedTimeInMins;
const getTimeDiff_1 = require("../getTimeDiff");
function getNotificationsFinishedTimeInMins(offer) {
    const notificationsFinishedAt = offer.display?.finishSendingAt ?? offer.createdAt;
    const notificationFinishedDiffMins = (0, getTimeDiff_1.getTimeDiffInMinutes)(Date.now(), notificationsFinishedAt);
    return notificationFinishedDiffMins;
}
//# sourceMappingURL=getNotificationsFinishedTimeInMins.js.map